import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import './WaitingTickets.css';

export default function Tickets() {
  const waitingTickets = useSelector(state => state.waitingTickets);
  const user = useSelector(state => state.user);
  const isPageVisible = useRef(true);
  const notificationIntervalRef = useRef(null);

  // Função para exibir uma notificação se a permissão estiver concedida e a página não estiver visível
  function showNotification() {
    if (!('Notification' in window)) {
      console.log('Este navegador não suporta notificações.');
    } else if (Notification.permission === 'granted' && !isPageVisible.current) {
      new Notification('CODE.ONE', { body: 'Você tem senhas em espera.' });
    }
  }

  const handleShowNotificationInterval = React.useCallback(() => {
    clearInterval(notificationIntervalRef.current);
    notificationIntervalRef.current = setInterval(() => {
      console.log('handleShowNotificationInterval');
      if (waitingTickets.data.summary.length > 0) {
        showNotification();
      } else {
        clearInterval(notificationIntervalRef.current);
      }
    }, 60000);
  }, [waitingTickets.data.summary.length]);

  // Verifica se deve exibir notificação e solicitar permissão
  useEffect(() => {
    if (user.data.receivePasswordsOnHold === 'T' && 'Notification' in window) {
      Notification.requestPermission().then(permission => {
        if (permission !== 'granted') {
          console.warn('Permissão para notificações não foi concedida.');
        } else {
          handleShowNotificationInterval();
        }
      });
    }
  }, [user.data.receivePasswordsOnHold, handleShowNotificationInterval]);

  // Atualiza o estado da página (visível ou não) quando o evento visibilitychange ocorre
  useEffect(() => {
    const handleVisibilityChange = () => {
      isPageVisible.current = !document.hidden;
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      clearInterval(notificationIntervalRef.current);
    };
  }, []);

  return (
    <div className="waiting-tickets-container">
      <div className="card w-100">
        <div className="card-body">
          <h5 className="card-title text-center">Senhas em espera</h5>
          {waitingTickets.data.summary.map(line => (
            <div className="col-12" key={line.id}>
              <div className="row mt-2">
                <div className="col-10 p-0 text-truncate">
                  <div className="line-indicator" style={{ backgroundColor: line.color }} />
                  <span className="ml-1">{line.name}</span>
                </div>
                <div className="col-2 p-0 text-center">{line.count}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
